module.exports = __webpack_public_path__ + "img/logo-white.4198f727.png";